"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetGalleryFieldIsTitleGallery = void 0;
var OfferAssetGalleryFieldIsTitleGallery_1 = require("./OfferAssetGalleryFieldIsTitleGallery");
Object.defineProperty(exports, "OfferAssetGalleryFieldIsTitleGallery", { enumerable: true, get: function () { return OfferAssetGalleryFieldIsTitleGallery_1.OfferAssetGalleryFieldIsTitleGallery; } });
